var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.95982 16.868C7.66073 17.759 8.76182 18.3332 10 18.3332C11.2382 18.3332 12.3393 17.759 13.0402 16.868C11.022 17.1415 8.97798 17.1415 6.95982 16.868Z",
    fill: "#5A5A5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6243 7.49984V8.08659C15.6243 8.79075 15.8252 9.47915 16.2018 10.065L17.1247 11.5008C17.9676 12.8122 17.3241 14.5948 15.858 15.0095C12.0227 16.0943 7.97728 16.0943 4.14197 15.0095C2.67587 14.5948 2.03235 12.8122 2.8753 11.5008L3.79816 10.065C4.17476 9.47915 4.37573 8.79075 4.37573 8.08659V7.49984C4.37573 4.27818 6.8938 1.6665 10 1.6665C13.1062 1.6665 15.6243 4.27818 15.6243 7.49984Z",
    fill: "#5A5A5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.872a5bddbe5d4f1104eb1ba194b39090.svg";
export { ForwardRef as ReactComponent };